import { render, staticRenderFns } from "./HomeNews.vue?vue&type=template&id=a016333a&scoped=true"
import script from "./HomeNews.vue?vue&type=script&lang=js"
export * from "./HomeNews.vue?vue&type=script&lang=js"
import style0 from "./HomeNews.vue?vue&type=style&index=0&id=a016333a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a016333a",
  null
  
)

/* custom blocks */
import block0 from "./HomeNews.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports